module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staff-boxs"
  }, [_c('div', {
    staticClass: "top-bar com-model m-b-15"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/staff/list'
      }
    }
  }, [_vm._v("员工管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("更换管理员")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "staffmanage"
  }, [_c('div', {
    staticClass: "st-change-bar m-b-20"
  }, [_vm._v("修改完成后，绑定的安全手机将会被修改！")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    class: {
      'regyzmYfs': _vm.issend
    },
    staticStyle: {
      "margin-left": "40px",
      "padding": "0 40px"
    },
    on: {
      "click": _vm.getcode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.yzmtxt) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("选择新的管理员")]), _vm._v(" "), _c('div', {
    staticClass: "value select-box"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newHrId),
      callback: function($$v) {
        _vm.newHrId = $$v
      },
      expression: "newHrId"
    }
  }, _vm._l((_vm.enableList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stepbtn",
    on: {
      "click": _vm.changeAdm
    }
  }, [_vm._v("完成")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ead6ec80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staff/changeadm.vue
// module id = 922
// module chunks = 1